import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/logo_btm.png'


const _withScopeId = n => (_pushScopeId("data-v-73a18338"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex flex-col" }
const _hoisted_2 = { class: "flex flex-col items-center justify-center w-full mb-[64px] p-3" }
const _hoisted_3 = { class: "p-[10px] text-center" }
const _hoisted_4 = { class: "p-[10px] text-center" }
const _hoisted_5 = { class: "p-[10px] text-center" }
const _hoisted_6 = { class: "flex flex-col items-center justify-center gap-y-12" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "w-[187px]"
}, null, -1))
const _hoisted_8 = {
  key: 0,
  class: "show fixed bg-[var(--bg-color)] inset-0 overflow-scroll z-50"
}

import BaseTypography from '@/components/common/BaseTypography.vue';
import BaseButton from '@/components/common/BaseButton.vue';
import BaseLine from '@/components/common/BaseLine.vue';
import Form from '@/components/Index/Form.vue';
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';


export default /*#__PURE__*/_defineComponent({
  __name: 'NinthSection',
  setup(__props) {

const { t } = useI18n();

const toggle = ref<boolean>(false);

const toggleForm = () => (toggle.value = !toggle.value);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(BaseTypography, {
            text: _unref(t)('main-page.ninth-section.first'),
            type: "title-m",
            class: "mb-2"
          }, null, 8, ["text"]),
          _createVNode(BaseLine, { width: "291" })
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(BaseTypography, {
            text: _unref(t)('main-page.ninth-section.second'),
            type: "title-m",
            class: "mb-2"
          }, null, 8, ["text"]),
          _createVNode(BaseLine, { width: "220" })
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(BaseTypography, {
            text: _unref(t)('main-page.ninth-section.third'),
            type: "title-m",
            class: "mb-2"
          }, null, 8, ["text"]),
          _createVNode(BaseLine, { width: "136" })
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _createVNode(BaseButton, {
          text: _unref(t)('main-page.submit'),
          type: "subtitle4-m",
          color: "var(--base-white)",
          ui: "primary-with-back",
          onClick: toggleForm
        }, null, 8, ["text"])
      ])
    ]),
    (toggle.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createVNode(Form, { onClose: toggleForm })
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})